import { render, staticRenderFns } from "./SocketMessage.vue?vue&type=template&id=53f62db6&scoped=true&"
import script from "./SocketMessage.vue?vue&type=script&lang=js&"
export * from "./SocketMessage.vue?vue&type=script&lang=js&"
import style0 from "./SocketMessage.vue?vue&type=style&index=0&id=53f62db6&prod&lang=scss&scoped=true&"
import style1 from "./SocketMessage.vue?vue&type=style&index=1&id=53f62db6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f62db6",
  null
  
)

export default component.exports